export const defaultSteps = [
  {
    title: "Create your free account",
    description: "Sign up with your email or social media account.",
  },
  {
    title: "Enroll in this course",
    description: "Choose between a verified certificate or an audit track.",
  },
  {
    title: "Start learning immediately",
    description: "Access all of your course materials and begin learning.",
  },
];

export const defaultPromo = {
  headline: "Ignite your career with up to 30% off!",
  subtext:
    "Learn new skills and make big moves for your career. Get up to 30% off with code SMARTEDX25. Offer ends June 19, 2025.",
  ctaLabel: "Advance your career",
  infoText:
    "Offer is valid until July 30, 2025, at 11:59 p.m. Eastern Time (U.S.). Offer does not apply to degree programs. Offer cannot be combined with other discount codes. To redeem the offer for verified courses, Professional Certificates, XSeries, MicroBachelors® Programs, and MicroMasters® Programs, use code LEVELUPEDX25 at checkout on edX.org. Learn more.",
};

export const programDetailPageEventConfig = {
  name: "testimonials-module",
  htmlId: "testimonials-module",
  location: "detail-page",
  elementType: "testimonials-module",
};
